import { call, put, takeEvery, select } from "redux-saga/effects";
import {
  bankDetailsLoading,
  setBankDetails,
  setBankDetailsForUser,
} from "./actions";
import {
  getBankDetails,
  getBankDetailsByUser,
  patchBankDetails,
  deleteBankDetails,
  postBankDetails,
} from "../../helpers/jwt_helper.js";
import {
  GET_BANK_DETAILS,
  GET_BANK_DETAILS_FOR_USER,
  UPDATE_BANK_DETAILS,
  DELETE_BANK_DETAILS,
  ADD_BANK_DETAILS,
} from "./actionTypes";

import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetBankDetailsForUser({ payload: id }) {
  try {
    yield put(bankDetailsLoading());
    yield put(setBankDetailsForUser({}));
    const response = yield call(getBankDetailsByUser, { user: id });
    yield put(setBankDetailsForUser(response));
    yield put(bankDetailsLoading());
  } catch (error) {
    yield put(bankDetailsLoading());
    //showErrorMessage(getErrorMessage(error));
  }
}

function* onAddBankDetails({ payload: data }) {
  try {
    yield put(bankDetailsLoading());
    const response = yield call(postBankDetails, data);
    yield put(setBankDetailsForUser(response));
    yield call(onGetBankDetailsForUser, {
      payload: data.user,
    });
    yield put(bankDetailsLoading());
  } catch (error) {
    yield put(bankDetailsLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchBankDetails({ payload: { id, data, user } }) {
  try {
    yield put(bankDetailsLoading());
    yield call(patchBankDetails, id, data);
    // yield put(setBankDetailsForUser(response));
    yield call(onGetBankDetailsForUser, {
      payload: user,
    });
    yield put(bankDetailsLoading());
    showSuccessMessage(`Updating bank information has been successfully`);
  } catch (error) {
    yield put(bankDetailsLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetBankDetails() {
  try {
    // const response = yield call(getChats);
  } catch (error) {}
}

function* onDeleteBankDetails({ payload: {id, user} }) {
  try {
    yield put(bankDetailsLoading());
    yield call(deleteBankDetails, id);
    yield call(onGetBankDetailsForUser, {
      payload: user,
    });
    yield put(bankDetailsLoading());
    showSuccessMessage(`Bank details has been cleared`);
  } catch (error) {
    yield put(bankDetailsLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* bankDetailsSaga() {
  yield takeEvery(GET_BANK_DETAILS, onGetBankDetails);
  yield takeEvery(GET_BANK_DETAILS_FOR_USER, onGetBankDetailsForUser);
  yield takeEvery(ADD_BANK_DETAILS, onAddBankDetails);
  yield takeEvery(UPDATE_BANK_DETAILS, onPatchBankDetails);
  yield takeEvery(DELETE_BANK_DETAILS, onDeleteBankDetails);
}

export default bankDetailsSaga;
